if (!customElements.get('ly-match-your-pergola')) {
    customElements.define('ly-match-your-pergola', class extends HTMLElement {

        #stepDoms = []
        #steps = []

        #form = {}

        connectedCallback() {
            this.#stepDoms = [...this.querySelectorAll('[data-match-step]')]
            this.#steps = this.#stepDoms.map(item => item.dataset.matchStep)

            this.addEventListener('next', this.handleNext)
        }

        disconnectedCallback() {
            this.removeEventListener('next', this.handleNext)
        }

        handleNext = (evt) => {
            const { current, data } = evt.detail

            Object.assign(this.#form, data)

            this.updateNextStep(current)
        }

        updateNextStep = (currentStep) => {
            const currentIndex = this.#steps.indexOf(currentStep)
            if (currentIndex >= this.#steps.length - 1) return
            const nextIndex = currentIndex + 1
            const nextStep = this.#steps[nextIndex]
            this.#stepDoms.forEach(item => {
                item.classList.toggle('is-current', item.dataset.matchStep === nextStep)
            })

            if (nextStep === 'email') {
                const result = this.#stepDoms[nextIndex + 2]?.searchResult?.(this.#form)
                this.#stepDoms[nextIndex]?.updateCount?.(result.showrooms.length)
            }

            if (nextStep === 'loading') {
                this.#stepDoms[nextIndex]?.run?.()

                this.#stepDoms[nextIndex + 1]?.render?.(this.#form)

                API.addMatchYourPergolaQuiz(this.#form)
            }

            if (currentStep === 'result') {
                this.#form = {}
            }
        }
    })
}

class LyMatchStepForm extends HTMLElement {

    #form = null
    #checkboxs = []

    connectedCallback() {
        this.#form = this.querySelector('form')
        if (!this.#form) return
        this.#checkboxs = [...this.#form?.querySelectorAll('input[type="checkbox"]')]

        this.#form?.addEventListener('submit', this.#handleSubmit)
    }

    disconnectedCallback() {
        this.#form?.removeEventListener('submit', this.#handleSubmit)
    }

    #handleSubmit = (evt) => {
        evt.preventDefault()

        if (this.#checkboxs.length && !this.checkedboxNum) {
            return
        }

        const formData = new FormData(evt.target)
        const data = Object.fromEntries(formData.entries())

        this._dispatchEvent(data)
    }

    get checkedboxNum() {
        return this.#checkboxs.filter(item => item.checked).length
    }

    _dispatchEvent = (data) => {
        this.dispatchEvent(new CustomEvent('next', {
            bubbles: true,
            detail: {
                current: this.dataset.matchStep,
                data: data ?? {},
                index: this.dataset.index
            }
        }))
    }
}

if (!customElements.get('ly-match-step-form')) {
    customElements.define('ly-match-step-form', LyMatchStepForm)
}

if (!customElements.get('ly-match-your-pergola-email')) {
    customElements.define('ly-match-your-pergola-email', class extends LyMatchStepForm {

        connectedCallback() {
            super.connectedCallback()

            this.countSpan = this.querySelector('[data-count]')
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        updateCount = (count) => {
            this.countSpan.textContent = count || ''
        }
    })
}

if (!customElements.get('ly-match-your-pergola-loading')) {
    customElements.define('ly-match-your-pergola-loading', class extends LyMatchStepForm {

        connectedCallback() {
            super.connectedCallback()
        }

        disconnectedCallback() {
            super.disconnectedCallback()
        }

        run = () => {
            setTimeout(() => {
                this._dispatchEvent()
            }, 3000)
        }
    })
}

if (!customElements.get('ly-match-your-pergola-result')) {
    customElements.define('ly-match-your-pergola-result', class extends HTMLElement {
        results = []

        connectedCallback() {
            const script = this.querySelector('script[type="application/json"]')
            this.results = readJsonFromScript(script)

            this.titleWrapper = this.querySelector('.ly-match-your-pergola-result-title')
            this.answersWrapper = this.querySelector('.ly-match-your-pergola-result-answers')
            this.showroomsWrapper = this.querySelector('.ly-match-your-pergola-result-cards-inner')
        }

        disconnectedCallback() {

        }

        render = (form) => {
            const result = this.searchResult(form)
            this.titleWrapper.textContent = result?.title
            this.renderAnswers(form)
            this.renderShowrooms(result)
        }

        searchResult = (form) => {
            return this.results.find(item => {
                let active = true
                const { questions, answers } = item
                for (let i = 0; i < Math.min(questions.length, answers.length); i++) {
                    const q = questions[i]
                    const a = answers[i]
                    if (form[q] !== a) {
                        active = false
                        break
                    }
                }
                return active
            })
        }

        renderAnswers = (form) => {
            this.answersWrapper.innerHTML = Object.entries(form).map(([k, v]) => {
                if (k === 'email') return null
                return `<div class="ly-match-your-pergola-result-answer">${v}</div>`
            }).filter(Boolean).join('')
        }

        renderShowrooms = (result) => {
            if (!result || !result.showrooms.length) return

            this.showroomsWrapper.innerHTML = result.showrooms.map(showroom => {

                const mediaSrc = `${showroom.media}&width=400`
                const mediaSrcset = [1, 2, 3].map(r => `${showroom.media}&width=${400 * r} ${r}x`).join(',')

                const optionsHtml = showroom.options.map(o => {
                    return `
                    <div class="ly-match-your-pergola-result-card-option">
                      ${o}
                    </div>
                    `
                }).join('')

                let avatarHtml = ``
                if (showroom.host_avatar) {
                    const src = `${showroom.host_avatar}&width=36`
                    const srcset = [1, 2, 3].map(r => `${showroom.host_avatar}&width=${36 * r} ${r}x`).join(',')
                    avatarHtml = `
                    <img
                      src="${src}"
                      srcset="${srcset}"
                      width="36"
                      height="36"
                      loading="lazy"
                    >
                    `
                } else {
                    avatarHtml = `${showroom.host_name.substring(0, 1)}`
                }

                return `
                <a class="ly-match-your-pergola-result-card" href="/pages/showroom-detail/${showroom.room_id}">
                  <div class="ly-match-your-pergola-result-card-inner">
                    <div class="ly-match-your-pergola-result-card-img">
                      <img
                        src="${mediaSrc}"
                        srcset="${mediaSrcset}"
                        width="408"
                        height="284"
                        loading="lazy"
                      >

                      <div class="ly-match-your-pergola-result-card-cover-address">
                        <span class="svg-wrapper">
                            <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.0957 0.896484C10.9848 0.896621 14.1855 3.87804 14.1855 7.61328C14.1853 10.2319 12.4085 12.6051 10.7393 14.2705C9.89293 15.1148 9.04826 15.8035 8.41602 16.2803C8.09956 16.5189 7.83454 16.7047 7.64844 16.832C7.55537 16.8957 7.4815 16.9451 7.43066 16.9785C7.40537 16.9951 7.38568 17.0078 7.37207 17.0166C7.36525 17.021 7.36018 17.025 7.35645 17.0273C7.35462 17.0285 7.35262 17.0296 7.35156 17.0303H7.35059V17.0312L7.0957 16.6299L7.34961 17.0312C7.19475 17.129 6.99668 17.129 6.8418 17.0312V17.0303H6.83984C6.8389 17.0297 6.83745 17.0284 6.83594 17.0273C6.83231 17.025 6.82685 17.0208 6.82031 17.0166C6.80672 17.0078 6.78599 16.9951 6.76074 16.9785C6.70999 16.9452 6.63667 16.8955 6.54395 16.832C6.35792 16.7047 6.09271 16.5188 5.77637 16.2803C5.14418 15.8036 4.29942 15.1148 3.45312 14.2705C1.78385 12.6051 0.00707422 10.232 0.00683594 7.61328C0.00683594 3.87806 3.20668 0.89666 7.0957 0.896484ZM7.09766 5.30859C5.69278 5.30859 4.55398 6.41057 4.55371 7.76953C4.55371 9.12872 5.69261 10.2314 7.09766 10.2314C8.50265 10.2314 9.6416 9.12869 9.6416 7.76953C9.64133 6.4106 8.50249 5.30864 7.09766 5.30859Z" fill="currentColor"/>
                            </svg>
                        </span>
                        <span>
                          ${showroom.address}
                        </span>
                      </div>
                    </div>

                    <div class="ly-match-your-pergola-result-card-info">
                      <div class="ly-match-your-pergola-result-card-title">
                        ${showroom.collection_card_title}
                      </div>
  
                      <div class="ly-match-your-pergola-result-card-description">
                        ${showroom.collection_card_description}
                      </div>
  
                      <div class="ly-match-your-pergola-result-card-options">
                        ${optionsHtml}
                      </div>

                      <div class="ly-match-your-pergola-result-card-footer">
                        <div class="ly-match-your-pergola-result-card-host">
                          <div class="ly-match-your-pergola-result-card-host-avatar">
                            ${avatarHtml}
                          </div>
                          <div class="ly-match-your-pergola-result-card-host-name">${showroom.host_name}</div>
                        </div>

                        <div class="ly-match-your-pergola-result-card-status ${showroom.accessible != true ? 'is-disabled' : ''}">
                          <span class="svg-wrapper">
                            <svg width="23" height="18" viewBox="0 0 23 18" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.6052 8.86328L19.4668 6.14503V2.0869C19.4668 1.89232 19.1945 1.73635 18.8581 1.73635H17.6397C17.3024 1.73635 17.0301 1.89234 17.0301 2.0869V4.0333L15.2291 2.47233L13.1999 0.713975C13.0737 0.585507 12.9447 0.473525 12.813 0.378102C12.6616 0.267976 12.5055 0.181736 12.3468 0.119309C12.1511 0.0422282 11.9509 0 11.7471 0C11.5433 0 11.344 0.0422041 11.1483 0.119309C10.9896 0.181736 10.8335 0.267976 10.6811 0.378102C10.5495 0.473525 10.4205 0.585507 10.2951 0.713975L8.26598 2.47233L4.45751 5.7724L0.888932 8.86328C0.71939 9.0119 0.698643 9.27071 0.843841 9.44324L1.81243 10.6014C1.95763 10.7739 2.21284 10.796 2.38148 10.6473L4.45751 8.8486L8.15684 5.64212L11.7471 2.53109L15.3364 5.64212L19.0366 8.8486L21.1126 10.6473C21.2822 10.796 21.5374 10.7739 21.6817 10.6014L22.6503 9.44324C22.7955 9.27071 22.7747 9.0119 22.6052 8.86328Z" />
                                <path d="M11.7925 3.69287L8.20226 6.8039L4.50293 10.0103V17.6273C4.50293 17.8329 4.60393 17.9999 4.73017 17.9999H10.2774V12.9176H13.3075V17.9999H18.8547C18.9801 17.9999 19.082 17.8329 19.082 17.6273V10.0103L15.3827 6.8039L11.7925 3.69287Z" />
                            </svg>
                          </span>
                          <span class="ly-p">
                            ${showroom.accessible ? 'Open for Visit' : 'Opening Soon'}
                          </span>
                        </div>
                      </div>

                    </div>

                  </div>
                </a>
                `
            }).join('')
        }
    })
}

if (!customElements.get('ly-match-your-pergola-result-contact')) {
    customElements.define('ly-match-your-pergola-result-contact', class extends HTMLElement {

        formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        })

        weekdayFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York',
            weekday: 'short'
        })

        weekdayMap = {
            Sun: 0,
            Mon: 1,
            Tue: 2,
            Wed: 3,
            Thu: 4,
            Fri: 5,
            Sat: 6
        }

        connectedCallback() {
            this.update()

            this.timer = setInterval(() => {
                this.update()
            }, 10 * 60_000)
        }

        disconnectedCallback() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        }

        update = () => {
            this.classList.toggle('is-working', this.isWorkingTime())
        }

        isWorkingTime = () => {
            const now = new Date()

            // 时间（小时 + 分钟）
            const timeParts = this.formatter.formatToParts(now)
            const hour = Number(timeParts.find(p => p.type === 'hour').value)
            const minute = Number(timeParts.find(p => p.type === 'minute').value)

            const totalMinutes = hour * 60 + minute

            // weekday（转数字）
            const weekdayStr = this.weekdayFormatter.format(now)

            const day = this.weekdayMap[weekdayStr]

            const isWeekend = day === 0 || day === 6

            // 周末：11:00 - 22:00
            if (isWeekend) {
                return totalMinutes >= 11 * 60 && totalMinutes < 22 * 60
            }

            // 工作日：08:00 - 22:00
            return totalMinutes >= 8 * 60 && totalMinutes < 22 * 60
        }
    })
}